export default "__VITE_ASSET__6baaa9b3__"